export default __webpack_public_path__ + "static/media/5.1e911fc7.png";